export default "__VITE_ASSET__DBpjsHZU__"